import React from 'react'

const SimpleModal = ({ isOpen, children, overlayClick }) => {
    return (
        isOpen && (
            <div className="simplemodal">
                <div
                    className="simplemodal__overlay"
                    onClick={overlayClick}
                ></div>
                <div className="simplemodal__content">{children}</div>
            </div>
        )
    )
}

export default SimpleModal
